import { ThemeUICSSObject } from '@apia/theme';

export const styles: ThemeUICSSObject = {};
